import { css } from "@emotion/react";
import styled from "@emotion/styled";

import PlayIcon from "./icon_play.svg";

export const playIconBackgroundStyles = css`
  .ytPfpControlsLargePlayButtonIconBg {
    fill-opacity: 0.7;

    transition: fill-opacity 0.2s ease;
  }
`;

/** Compose inside a `:hover` rule that targets the icon — never at rest. */
export const playIconBackgroundHoverStyles = css`
  .ytPfpControlsLargePlayButtonIconBg {
    fill-opacity: 1;
  }
`;

export const Container = styled.div`
  position: absolute;
  inset-block-start: 8px;
  inset-inline-end: 8px;
`;

export const StyledPlayIcon = styled(PlayIcon)`
  ${playIconBackgroundStyles}
`;
